<template>
  <adminTable
    ref="adminTableRef"
    :tableLoading="tableLoading"
    :totalList="totalList"
    v-model:page="page"
    v-model:limit="limit"
    v-model:searchForm="searchForm"
    :tableData="tableData"
    @search="getList"
  >
    <template v-slot:form-inline-items>
      <el-form-item>
        <el-input v-model="searchForm.username" placeholder="请输入用户名" clearable />
      </el-form-item>
      <el-form-item>
        <el-input v-model="searchForm.phone" placeholder="请输入手机号码" clearable />
      </el-form-item>
      <el-form-item>
        <el-select v-model="searchForm.status" placeholder="状态" clearable>
          <el-option
            v-for="item in sfzStatusEnums"
            :label="item.label"
            :value="item.value"
            :key="item.label"
          />
        </el-select>
      </el-form-item>
      <el-form-item>
        <div class="date-range-picker">
          <el-date-picker
            v-model="searchForm.starttime"
            type="datetime"
            value-format="YYYY-MM-DD HH:mm:ss"
            placeholder="开始时间"
            class="flex-1"
          />
          <span class="date-separator">-</span>
          <el-date-picker
            v-model="searchForm.endtime"
            type="datetime"
            value-format="YYYY-MM-DD HH:mm:ss"
            placeholder="结束时间"
            class="flex-1"
          />
        </div>
      </el-form-item>
    </template>
    <template v-slot:query-button-right>
      <el-button
        type="primary"
        v-permission
        @click="editItem('add', {})"
      >
        添加
      </el-button>
    </template>
    <template v-slot:table>
      <el-table-column prop="id" label="ID" width="60" />
      <el-table-column prop="phone" label="电话" width="150" />
      <el-table-column prop="type" label="类型" width="120">
        <template #default="scope">
          <span>{{ getLabelByVal(scope.row.type, couponTypeEnums) }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="allow" label="最小使用金额" width="150" />
      <el-table-column prop="amount" label="数额" width="160">
        <template #default="scope">
          <span v-if="scope.row.type === 1">{{ scope.row.rate }}%</span>
          <span v-else>{{ scope.row.amount }}元</span>
        </template>
      </el-table-column>
      <el-table-column prop="status" label="状态" width="200">
        <template #default="scope">
          <span>{{ getLabelByVal(scope.row.status, couponStatusEnums) }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="expire_time" label="过期时间" width="130" />
      <el-table-column label="操作" width="200" fixed="right">
        <template #default="scope">
          <el-button
            type="primary"
            icon="Edit"
            size="small"
            v-permission
            @click="editItem('edit', scope.row)"
          >
            编辑
          </el-button>
          <el-button
            type="danger"
            icon="Delete"
            size="small"
            v-permission
            @click="deleteAction(scope.row)"
          >
            删除
          </el-button>
        </template>
      </el-table-column>
    </template>
    <el-dialog v-model="dialogFlag" title="编辑/新增" width="1200">
      <editPop :key="editRow" ref="editFormRef" :item="editRow" />

      <template #footer>
        <div class="dialog-footer">
          <el-button size="small" @click="closeDialog">关闭</el-button>
          <el-button size="small" type="primary" @click="submitForm"> 保存 </el-button>
        </div>
      </template>
    </el-dialog>
  </adminTable>
</template>

<script setup>
import { ref, getCurrentInstance, onMounted } from "vue";
import { couponStatusEnums, couponTypeEnums, getLabelByVal, sfzStatusEnums } from "@/config/enums";
import EditPop from "./components/discountList/editPop.vue";
import { useRoute } from "vue-router";
import { ElMessage, ElMessageBox } from "element-plus";

const route = useRoute();
const { proxy } = getCurrentInstance();

// 搜索表单
const searchForm = ref({
  starttime: "",
  endtime: "",
  username: "",
  phone: "",
  status: "",
});

// 表格相关
const tableData = ref([]);
const page = ref(1);
const limit = ref(10);
const totalList = ref(0);
const tableLoading = ref(false);
const adminTableRef = ref(null);

// 对话框相关
const dialogFlag = ref(false);
const editRow = ref({});
const editFormRef = ref(null);
const formType = ref("add");

// 初始化
onMounted(() => {
  if (route.query && route.query.phone) {
    searchForm.value.phone = route.query.phone;
  }
  getList();
});

// 获取列表数据
const getList = async () => {
  tableLoading.value = true;
  const res = await proxy.$http({
    method: "get",
    url: "/Coupon/getCouponLists",
    params: {
      page: page.value,
      limit: limit.value,
      ...searchForm.value,
    },
  });
  tableLoading.value = false;
  if (res.code == 0) {
    tableData.value = res.data.data;
    totalList.value = res.data.total;
  }
};

// 编辑/添加项目
const editItem = (type, row = {}) => {
  formType.value = type;
  editRow.value = row;
  dialogFlag.value = true;
};

// 关闭对话框
const closeDialog = () => {
  dialogFlag.value = false;
  editRow.value = {};
  formType.value = "add";
};

// 提交表单
const submitForm = async () => {
  const url = formType.value === "add" ? "/Coupon/addCoupon" : "/Coupon/updateCoupon";
  const data = editFormRef.value.form;
  if (formType.value === "add") {
    data.id = null;
  }

  const res = await proxy.$http({
    method: "post",
    url: url,
    data: {
      phone: data.phone,
      amount: data.amount,
      status: data.status,
      type: data.type,
      expire_time: data.expire_time,
      id: data.id,
      rate: data.rate,
      allow: data.allow,
    },
  });
  
  if (res.code == 0) {
    ElMessage.success("操作成功");
    closeDialog();
    getList();
  } else {
    ElMessage.error(res.msg || "操作失败");
  }
};

// 删除操作
const deleteAction = (row) => {
  ElMessageBox.confirm("是否删除?", "提示", {
    confirmButtonText: "确认",
    cancelButtonText: "取消",
    type: "warning",
  })
    .then(async () => {
      const res = await proxy.$http({
        method: "get",
        url: "Coupon/deleteCoupon",
        params: {
          id: row.id,
        },
      });
      if (res.code == 0) {
        ElMessage.success("删除成功");
        getList();
      } else {
        ElMessage.error(res.msg || "删除失败");
      }
    })
    .catch(() => {});
};
</script>

<style lang="less" scoped>
// date-range-picker 样式已移至全局 form.less

.flex-1 {
  flex: 1;
}
</style>
